<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Payment"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.payment.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcPaymentHeader
      :payment="item"
      :config="config"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </UcPaymentHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="payment"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetPaymentGeneral
        :config="config"
        :payment="item"
        :transactionTypes="transactionTypes"
        :formId="formId"
        :reload="lastLoaded"
        :autocalcAmount="autocalcAmount"
        @accountChanged="evh_5534025912102772_accountChanged($event, {})"
        @autocalcAmountChanged="evh_5534025912102772_autocalcAmountChanged($event, {})"
      >
      </FieldsetPaymentGeneral>
    </ItpForm>
    <HR>
    </HR>
    <UcPaymentInvoices
      :payment="item"
      :reload="lastLoaded"
      @recalculate="evh_3083451129821185_recalculate($event, {})"
    >
    </UcPaymentInvoices>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.payment.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Create another payment'|pgettext('Button')"
      :disabled="!forms.payment || !forms.payment.submittable"
      variant="light"
      icon="mdi:forward"
      :spinning="actions.save.isRunning"
      v-if="!isNew"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="isNew ? messages.createPayment : messages.saveChanges"
      :disabled="!forms.payment || !forms.payment.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
      class="ml-auto mr-2"
      v-if="!item.isReadonly"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class Payment extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_autocalcAmount = new ComponentValueCache(this, "autocalcAmount", "PaymentInvoices.autocalcAmount");
  }

  recalculateAmountFromLines(...args: any[]) {
    const item = this.item;

    if (item.isReadonly) {
      return;
    }

    const [invoiceData] = args;

    if (invoiceData) {
      const idx = _.findIndex(item.invoices.data, { invoice_id: invoiceData.invoice_id });
      if (idx > -1) {
        _.extend(item.invoices.data[idx], invoiceData);
      }
    }

    if (!this.autocalcAmount) {
      return;
    }

    const summa = this.$fn.numeral(0);

    if (!item.invoices || !item.invoices.data) {
      return;
    }

    for (let d of item.invoices.data) {
      summa.add(d.amount);
    }

    item.amount = summa.value();

    if (this.isPettyCashPayment) {
      item.amount = Math.abs(item.amount);
    }
  }

  reloadTemplate(...args: any[]) {
    this.loadData('item')
  }

  @Prop({
    type: String,
    default: null,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Array,
    default: null,
  })
  invoices!: array;

  @Watch('invoices')
  onInvoices(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoices")
  }

  @Prop({
    type: String,
  })
  accountId!: string;

  @Watch('accountId')
  onAccount_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("accountId")
  }

  @Prop({
    type: String,
    default: null,
  })
  transactionKind!: string;

  @Watch('transactionKind')
  onTransaction_kind(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("transactionKind")
  }

  @Prop({
    type: String,
    default: null,
  })
  transactionType!: string;

  @Watch('transactionType')
  onTransaction_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("transactionType")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  autocalcAmount!: any;
  item!: any;

  async $$load_item() {
    return this.oid == null
      ? this.$fn.fetch(
        'get_payment_template', {
        asResource: true,
        parameters: {
          kind: this.transactionKind,
          type: this.transactionType,
          invoices: this.invoices ? this.invoices.join(',') : null,
          account_id: (this.$data.item && this.$data.item.account && this.$data.item.account.id) || this.accountId
        }
      }
      )
      : this.$fn.fetch('read_payment', { asResource: true, parameters: { id: this.oid } })
  }

  allConfig!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['messages', 'formId', 'autocalcAmount', 'item', 'allConfig', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          saveChanges: this.$fn.pgettext("Button", "Save changes"),
          createPayment: this.$fn.pgettext("Button", "Create payment"),
        }
        ,
        formId: null,
        autocalcAmount: true,
        item: null,
        allConfig: {
          transactionTypes: {
            bank: {
              credit: this.$fn.pgettext("TransactionType", "credit"),
              debit: this.$fn.pgettext("TransactionType", "debit"),
            }
            ,
            cash_book: {
              deposit: this.$fn.pgettext("TransactionType", "deposit"),
              payment: this.$fn.pgettext("TransactionType", "payment"),
            }
            ,
            technical: {
              invoice_reconciliation: this.$fn.pgettext("TransactionType", "invoice reconciliation"),
              write_off: this.$fn.pgettext("TransactionType", "write off"),
            }
            ,
          }
          ,
          bank: {
            credit: {
              fields: {
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Bank credit"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
            debit: {
              fields: {
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Bank debit"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
          }
          ,
          cash_book: {
            deposit: {
              fields: {
                transaction_number: false,
                transaction_type: "ro",
                exchange_rate: false,
                statement_number: false,
                transaction_code: false,
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Cash-In"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
            payment: {
              fields: {
                transaction_number: false,
                transaction_type: "ro",
                exchange_rate: false,
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Cash-Out"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
          }
          ,
          technical: {
            invoice_reconciliation: {
              fields: {
                amount: false,
                exchange_rate: false,
                transaction_number: false,
                payment_method: false,
                employee: false,
                statement_number: false,
                transaction_code: false,
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Invoice reconciliation"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
            write_off: {
              fields: {
                amount: false,
                exchange_rate: false,
                transaction_number: false,
                payment_method: false,
                employee: false,
                statement_number: false,
                transaction_code: false,
              }
              ,
              resourceTitle: this.$fn.pgettext("Payment|Header", "Write off"),
              newTransaction: this.$fn.pgettext("Payment|Header", "New transaction"),
            }
            ,
          }
          ,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get isDeletable() {
    if (this.loaded) {

      return this.oid != null
    }
    return null;
  }

  get isNew() {
    if (this.loaded) {

      return this.item && this.item.id == null
    }
    return null;
  }

  get isPettyCashPayment() {
    if (this.loaded) {

      return this.item.account && this.item.account.account_type === 'cash_book'
    }
    return null;
  }

  get config() {
    if (this.loaded) {

      return this.allConfig[this.item.transaction_kind][this.item.transaction_type]
    }
    return null;
  }

  get transactionTypes() {
    if (this.loaded) {

      return this.allConfig.transactionTypes[this.item.transaction_kind]
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4682_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4682, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_4690_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_4690, alias=undefined
    return {
      grid: "payments",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_4694_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_4694, alias=undefined
    return {
      path: "item",
      value: $event && $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_setData_4694_getWhen($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_4694, alias=undefined
    return !!$event.data
  }

  async act_1040167445267876_reloadSlickgrid_4696_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_4696, alias=undefined
    return {
      grid: "payments",
    }
  }

  async act_1040167445267876_reloadSlickgrid_4696_getWhen($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_4696, alias=undefined
    return !!$event.data
  }

  async act_1040167445267876_crud_4692_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_4692, alias=save
    return {
      objectType: "payment",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_script_4698_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5534025912102772_script_4698, alias=undefined
    this.reloadTemplate($event.data)
  }

  async act_5534025912102772_script_4698_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5534025912102772_script_4698, alias=undefined
    return {
      value: () => this.act_5534025912102772_script_4698_getActionArgs_value($event),
    }
  }

  async evh_5534025912102772_accountChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_accountChanged.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_setData_4700_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5534025912102772_setData_4700, alias=undefined
    return {
      path: "autocalcAmount",
      value: $event.originalEvent,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5534025912102772_autocalcAmountChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_autocalcAmountChanged.executeFromDOM(this, event, scope);
  }

  async act_3083451129821185_script_4702_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3083451129821185_script_4702, alias=undefined
    this.recalculateAmountFromLines($event.data)
  }

  async act_3083451129821185_script_4702_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3083451129821185_script_4702, alias=undefined
    return {
      value: () => this.act_3083451129821185_script_4702_getActionArgs_value($event),
    }
  }

  async evh_3083451129821185_recalculate(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3083451129821185_recalculate.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_setData_4704_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1548630417156826_setData_4704, alias=undefined
    return {
      path: "item",
      value: this.item.clone({
        id: null,
        rev: null,
        transaction_number: this.isPettyCashPayment ? null : this.item.transaction_number,
        amount: 0,
        links: null,
        etag: null,
        invoices: { data: [] },
        preview_url: null,
        locked: false,
        notes: null,
        internal_notes: null,
      }),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4682: actions.CloseModalAction;
    evh_7315092382398562_close_4681: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_4684: actions.CloseModalAction;
    evh_2248226175642056_close_4683: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_4686: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_4685: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeModal_4688: actions.CloseModalAction;
    evh_8564662037462133_deleted_4687: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_4690: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_4689: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_setData_4694: actions.SetDataAction;
    evh_1040167445267876_success_4693: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_4696: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_4695: actions.EventHandlerImpl;
    act_1040167445267876_crud_4692: actions.CRUDAction;
    evh_1040167445267876_submit_4691: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_script_4698: actions.ScriptAction;
    evh_5534025912102772_accountChanged_4697: actions.EventHandlerImpl;
    evh_5534025912102772_accountChanged: actions.EventHandlerGroup;
    act_5534025912102772_setData_4700: actions.SetDataAction;
    evh_5534025912102772_autocalcAmountChanged_4699: actions.EventHandlerImpl;
    evh_5534025912102772_autocalcAmountChanged: actions.EventHandlerGroup;
    act_3083451129821185_script_4702: actions.ScriptAction;
    evh_3083451129821185_recalculate_4701: actions.EventHandlerImpl;
    evh_3083451129821185_recalculate: actions.EventHandlerGroup;
    act_1548630417156826_setData_4704: actions.SetDataAction;
    evh_1548630417156826_clickPreventStop_4703: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4682 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4682_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4681 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4682,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4681],
      }
    );
    const act_2248226175642056_closeModal_4684 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4683 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_4684,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4683],
      }
    );
    const act_8564662037462133_reloadComponentData_4686 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_4685 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_4686,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_4685],
      }
    );
    const act_8564662037462133_closeModal_4688 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_4687 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeModal_4688,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const act_8564662037462133_reloadSlickgrid_4690 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_4690_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_4689 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_4690,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_4687, evh_8564662037462133_deleted_4689],
      }
    );
    const act_1040167445267876_setData_4694 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_4694_getActionArgs,
        when: this.act_1040167445267876_setData_4694_getWhen,
        events: [],
      }
    );
    const evh_1040167445267876_success_4693 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_4694,
        event: "success",
        displayName: "setData",
      }
    );
    const act_1040167445267876_reloadSlickgrid_4696 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_4696_getActionArgs,
        when: this.act_1040167445267876_reloadSlickgrid_4696_getWhen,
        events: [],
      }
    );
    const evh_1040167445267876_success_4695 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_4696,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_crud_4692 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_4692_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_4693, evh_1040167445267876_success_4695],
      }
    );
    const evh_1040167445267876_submit_4691 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_4692,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4691],
      }
    );
    const act_5534025912102772_script_4698 = new actions.ScriptAction(
      {
        actionArgs: this.act_5534025912102772_script_4698_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_accountChanged_4697 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_script_4698,
        event: "accountChanged",
        displayName: "script",
      }
    );
    const evh_5534025912102772_accountChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_accountChanged_4697],
      }
    );
    const act_5534025912102772_setData_4700 = new actions.SetDataAction(
      {
        actionArgs: this.act_5534025912102772_setData_4700_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_autocalcAmountChanged_4699 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_setData_4700,
        event: "autocalcAmountChanged",
        displayName: "setData",
      }
    );
    const evh_5534025912102772_autocalcAmountChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_autocalcAmountChanged_4699],
      }
    );
    const act_3083451129821185_script_4702 = new actions.ScriptAction(
      {
        actionArgs: this.act_3083451129821185_script_4702_getActionArgs,
        events: [],
      }
    );
    const evh_3083451129821185_recalculate_4701 = new actions.EventHandlerImpl(
      {
        action: act_3083451129821185_script_4702,
        event: "recalculate",
        displayName: "script",
      }
    );
    const evh_3083451129821185_recalculate = new actions.EventHandlerGroup(
      {
        handlers: [evh_3083451129821185_recalculate_4701],
      }
    );
    const act_1548630417156826_setData_4704 = new actions.SetDataAction(
      {
        actionArgs: this.act_1548630417156826_setData_4704_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_4703 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_setData_4704,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_4703],
      }
    );
    return {
      act_7315092382398562_closeModal_4682,
      evh_7315092382398562_close_4681,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_4684,
      evh_2248226175642056_close_4683,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_4686,
      evh_8564662037462133_reload_4685,
      evh_8564662037462133_reload,
      act_8564662037462133_closeModal_4688,
      evh_8564662037462133_deleted_4687,
      act_8564662037462133_reloadSlickgrid_4690,
      evh_8564662037462133_deleted_4689,
      evh_8564662037462133_deleted,
      act_1040167445267876_setData_4694,
      evh_1040167445267876_success_4693,
      act_1040167445267876_reloadSlickgrid_4696,
      evh_1040167445267876_success_4695,
      act_1040167445267876_crud_4692,
      evh_1040167445267876_submit_4691,
      evh_1040167445267876_submit,
      act_5534025912102772_script_4698,
      evh_5534025912102772_accountChanged_4697,
      evh_5534025912102772_accountChanged,
      act_5534025912102772_setData_4700,
      evh_5534025912102772_autocalcAmountChanged_4699,
      evh_5534025912102772_autocalcAmountChanged,
      act_3083451129821185_script_4702,
      evh_3083451129821185_recalculate_4701,
      evh_3083451129821185_recalculate,
      act_1548630417156826_setData_4704,
      evh_1548630417156826_clickPreventStop_4703,
      evh_1548630417156826_clickPreventStop,
      save: act_1040167445267876_crud_4692,
    }
  }
}

Vue.component("Payment", Payment);

</script>